'use client';

import {
    Footer as UdemyFooter,
    mapMonolithDataToFooterProps,
    FooterClientData,
} from '@udemy-v2/react-footer';
import {useFooterData} from '@/lib/hooks/use-footer-data';
import {useCommonData} from '@udemy-v2/common-data';
import {useFeatures} from '@udemy-v2/react-experimentation';
import {UBLinkPath, useUdemyBusinessLink} from '@udemy-v2/organization-growth';

export const Footer = () => {
    const footerData = useFooterData();
    const commonData = useCommonData();
    const {featureVariantAssignments} = useFeatures(['browse_aggregator_page', 'career_academies']);

    // Use same business link logic as header
    const ubDemoUrl = useUdemyBusinessLink(UBLinkPath.REQUEST_DEMO_MX, {
        ref: 'footer-ad',
        user_type: 'mx',
    });

    if (!footerData) {
        return null;
    }

    // Build client data for footer mapping
    const clientData: FooterClientData = {
        user: commonData?.user
            ? {
                  has_instructor_intent: !!commonData.user.isInstructor,
              }
            : null,
        footerExperimentFeatures: {
            isAggregatorEnabled:
                !!featureVariantAssignments.get('browse_aggregator_page')?.configuration
                    ?.pageEnabled,
            isAcademiesEnabled:
                !!featureVariantAssignments.get('career_academies')?.configuration?.feature,
        },
    };

    const footerProps = mapMonolithDataToFooterProps(footerData, clientData);

    return <UdemyFooter {...footerProps} ufbNoticeLink={ubDemoUrl} />;
};
